export default __webpack_public_path__ + "static/media/wyg-footer-bg.29f52093.png";